import React from 'react'

import { ModalForm, ModalFormRow, ModalFormBlock } from '../../components/modal-form/modal-form'
import ServicesSelectorContainer from '../../containers/forms/services-selector-container'

import at from 'lodash/at'
import cx from 'classnames'

export default class ServicingServicesUpdate extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showSuccess: false,
      errors: null
    }
  }

  onSubmit (event) {
    event.preventDefault()
    // this.props.onCheckCompletion().then(errors => {
    //   console.log(errors)
    // })
    this.props.handleSubmit(event)
      .then((errors) => {
        const { serviceIds } = this.props.fields

        if (errors && errors.length > 0) {
          this.setState({ errors: errors, disableButton: true })
        } else if (serviceIds.error) {
          // we're not doing anything in this case here
        } else {
          this.setState({ showSuccess: true })
          setTimeout(() => this.props.onSuccessFeedbackComplete(), 1000)
        }
      })
  }

  render () {
    const {
      fields: { serviceIds },
      workOrderId,
      completedServices,
      submitting
    } = this.props

    const { errors } = this.state

    const validations = {
      serviceIds: {
        valid: serviceIds.error,
        error: 'Please select at least one service.'
      }
    }
    const invalidFieldKeys = Object.keys(validations).filter(key => validations[key].valid)
    const invalidFields = at(validations, invalidFieldKeys)
    const containsInvalidFields = invalidFields.length > 0

    return (
      <div className='form'>
        {errors && errors.length > 0 &&
          errors.map((err, i) => (<p key={i} style={{color: 'red'}}>• {err.detail} {err.link !== null && <a href={err.link}>{err.linkDescription}</a>}</p>))
        }
        <ModalForm onSubmit={this.onSubmit.bind(this)}>
          <ModalFormRow>
            <ModalFormBlock>
              { containsInvalidFields && <p className={cx({'centered': true, 'error': true, hidden: !containsInvalidFields || submitting})}>
                {invalidFields.map(field => (<span>• {field.error}</span>))}
              </p>}
            </ModalFormBlock>
          </ModalFormRow>

          <ServicesSelectorContainer workOrderId={workOrderId} attribute={serviceIds} completedServices={completedServices} />

          <ModalFormRow>
            <ModalFormBlock submitButton>
              <button type='submit' disabled={submitting || this.state.showSuccess || !!this.state.disableButton}>
                {this.state.showSuccess ? '✓ Saved' : 'Update'}
              </button>
            </ModalFormBlock>
          </ModalFormRow>
        </ModalForm>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/servicings/servicing-services-update.js